import {
  ChangeDetectionStrategy,
  Component,
  inject,
  input,
} from '@angular/core';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { toObservable } from '@angular/core/rxjs-interop';
import { combineLatest, map, Observable, switchMap } from 'rxjs';
import {
  DateComponent,
  DetailsViewComponent,
  ExternalLinkComponent,
  ImageThumbnailComponent,
  ImageThumbnailUnsupportedComponent,
  NoDataComponent,
  SpinnerFilledComponent,
} from '@web/shared/ui';
import { Guid, isNotNil } from '@web/utils';
import { AdminBrandBannerDataSourceService } from '../../services/admin-brand-banner-data-source.service';
import { AdminBrandBannerDetails } from '../../models/admin-brand-banner-details';
import { AdminBrandBannerStatusPipe } from '../../pipes/admin-brand-banner-status.pipe';

@Component({
  selector: 'app-admin-brand-banner-details',
  imports: [
    AdminBrandBannerStatusPipe,
    CommonModule,
    DateComponent,
    DetailsViewComponent,
    ExternalLinkComponent,
    ImageThumbnailComponent,
    ImageThumbnailUnsupportedComponent,
    NgOptimizedImage,
    NoDataComponent,
    SpinnerFilledComponent,
  ],
  templateUrl: './admin-brand-banner-details.component.html',
  styleUrl: './admin-brand-banner-details.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AdminBrandBannerDetailsComponent {
  private readonly bannerDataSource = inject(AdminBrandBannerDataSourceService);

  public readonly brandId = input.required<Guid>();
  public readonly bannerId = input.required<Guid>();

  protected readonly brandId$ = toObservable(this.brandId);
  protected readonly bannerId$ = toObservable(this.bannerId);
  protected readonly details$ = this.detailsSource();
  protected readonly isNotNil = isNotNil;

  private detailsSource(): Observable<AdminBrandBannerDetails> {
    return combineLatest([this.brandId$, this.bannerId$]).pipe(
      map(([brandId, bannerId]) => ({ bannerId, brandId })),
      switchMap(({ bannerId, brandId }) =>
        this.bannerDataSource.fetchDetailsById({
          bannerId,
          brandId,
        }),
      ),
    );
  }
}
